// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import PhiContactController from "./phi_contact_controller";
application.register("phi-contact", PhiContactController)

import InsuranceController from "./insurance_controller";
application.register("insurance", InsuranceController)

import PartnerController from "./partner_controller"
application.register("partner", PartnerController)

import ObgynController from "./obgyn_controller";
application.register("obgyn", ObgynController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import FileUploadController from "./file_upload_controller";
application.register("file-upload", FileUploadController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import SavvycalEmbedController from "./savvycal_embed_controller"
application.register("savvycal-embed", SavvycalEmbedController)

import StripeCheckoutController from "./stripe_checkout_controller"
application.register("stripe-checkout", StripeCheckoutController)

import VisibilityController from "./visibility_controller"
import { Turbo } from "@hotwired/turbo-rails";
application.register("visibility", VisibilityController)

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

import HamburgerMenuController from "./hamburger_menu_controller"
application.register("hamburger-menu", HamburgerMenuController)

import AddressController from "./address_controller"
application.register("address", AddressController)

import EmailValidationController from "./email_validation_controller"
application.register("email-validation", EmailValidationController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import PostHogController from "./posthog_controller"
application.register("posthog", PostHogController)

import AppointmentsLinkController from "./appointments_link_controller"
application.register("appointments-link", AppointmentsLinkController)